import React, { useMemo } from 'react';
import { ReactTable } from '../../components';
import './style.sass';

const Table = ({ tableData, quizType }) => {
  console.log('Table Component - quizType:', quizType, 'tableData length:', tableData?.length);

  const getDefaultColumns = () => [
    { Header: 'No', accessor: 'question' },
    { Header: 'Your Answer', accessor: 'yourAnswer' },
    { Header: 'Correct Answer', accessor: 'correctAnswer' },
    { Header: 'Time', accessor: 'time' },
    { Header: 'Question Topic', accessor: 'questionTopic' },
  ];

  const getColumnsBasedOnQuizType = () => {
    const standardColumns = [
      { Header: 'No', accessor: 'question' },
      { Header: 'Your Answer', accessor: 'yourAnswer' },
      { Header: 'Correct Answer', accessor: 'correctAnswer' },
      { Header: 'Time', accessor: 'time' },
      { Header: 'Difficulty', accessor: 'difficulty' },
      { Header: 'Feedback', accessor: 'feedback' },
      { Header: 'Question Topic', accessor: 'questionTopic' },
      { Header: 'Question Sub-Topic', accessor: 'questionSubTopic' },
    ];

    switch (quizType) {
      case 'HSPT':
        return [
          { Header: 'No', accessor: 'question' },
          { Header: 'Your Answer', accessor: 'yourAnswer' },
          { Header: 'Correct Answer', accessor: 'correctAnswer' },
          { Header: 'Time', accessor: 'time' },
          { Header: 'Question Topic', accessor: 'questionTopic' },
        ];
      case 'SAT':
      case 'DSAT':
        return standardColumns;
      default:
        console.warn('Unknown quizType:', quizType, 'Using default columns');
        return getDefaultColumns();
    }
  };

  const columns = useMemo(() => getColumnsBasedOnQuizType(), [quizType]);

  // Fallback UI for empty tableData
  if (!tableData || tableData.length === 0) {
    console.warn('Table Component - tableData is empty or undefined');
    return (
      <div className="contents">
        <p>No questions available for the selected section.</p>
      </div>
    );
  }

  return (
    <div className="contents">
      <ReactTable columns={columns} data={tableData} pagination={false} />
    </div>
  );
};

export default Table;
